module.exports = __webpack_public_path__ + "static/media/id-man_light.3d284514.svg";